import React from 'react';
import { GiftIcon, PlusIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-navy-900 py-14 sm:py-20" data-id="element-99" data-mp="1cl64hf6kxujp">
      <div className="mx-auto w-full max-w-4xl px-5" data-id="element-100" data-mp="1clpod1fsit0d">
        <p className="flex items-center gap-2 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-gold-500" data-id="element-101" data-mp="18k4bhg39aeq6">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-102" data-mp="258sh1cxsc9ip" />
          Included at no extra cost
        </p>
        <h2 className="mt-3 font-display text-[1.7rem] font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-103" data-mp="20btlqr2dxwix">
          You’ll Also Receive These 5 Exclusive Bonuses
        </h2>

        <div className="mt-8 space-y-4" data-id="element-104" data-mp="1r90x6vkl7yws">
          {bonuses.map(bonus => <article key={bonus.label} className="rounded-3xl border border-white/10 bg-navy-950 p-5 sm:p-6" data-id="element-105" data-mp="kujhm25kdx24">
              <div className="flex flex-wrap items-center gap-3" data-id="element-106" data-mp="ftm2xzjrjl5d">
                <span className="rounded-lg bg-gold-500 px-2.5 py-1 font-display text-[0.68rem] font-extrabold uppercase tracking-[0.12em] text-navy-950" data-id="element-107" data-mp="1euq2ih73dg38">
                  {bonus.label}
                </span>
                <span className="text-[0.7rem] font-bold uppercase tracking-[0.1em] text-slate-400 line-through" data-id="element-108" data-mp="15s70u0f1l9ik">
                  Value {bonus.value}
                </span>
                <span className="rounded-lg border border-emerald-500/40 bg-emerald-500/10 px-2.5 py-1 text-[0.68rem] font-extrabold uppercase tracking-[0.12em] text-emerald-400" data-id="element-109" data-mp="w2x76g4jvisc">
                  Free today
                </span>
              </div>

              <h3 className="mt-4 font-display text-lg font-extrabold leading-tight text-white sm:text-xl" data-id="element-110" data-mp="n0e9eafmfwcy">
                {bonus.title}
              </h3>
              <p className="mt-2 font-semibold leading-snug text-cyan-bright" data-id="element-111" data-mp="d5cjvdhfos9u">
                {bonus.hook}
              </p>
              <p className="mt-2.5 text-[0.92rem] leading-relaxed text-slate-300" data-id="element-112" data-mp="i2mgpe75k67p">
                {bonus.description}
              </p>

              {bonus.bullets ? <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-113" data-mp="2f0sekycjso4x">
                  {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2 rounded-xl bg-white/5 px-3 py-2 text-[0.86rem] leading-snug text-slate-200" data-id="element-114" data-mp="2b0roggg36oi1">
                      <PlusIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-500" aria-hidden="true" data-id="element-115" data-mp="32qmop85hfylh" />
                      {bullet}
                    </li>)}
                </ul> : null}
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-116" data-mp="1ic3yw8ob1cyo">
          <CTAButton label="I want the Clinical Route + all 5 bonuses" note="The bonuses are included with your access" tone="gold" data-id="element-117" data-mp="1icvv9lpq7eq0" />
        </div>
      </div>
    </section>;
}